module.exports = __webpack_public_path__ + "static/img/1666_phase_function_Paper_Points.aced89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1666_phase_function_Paper_Points.png
// module id = lsDA
// module chunks = 0